import { h } from "preact";
import { useState } from "preact/hooks";

import { Keyboard } from "../../../../foundation/enums";
import Input from "../../Input";
import Dialog, { DialogProps } from "..";

import styles from "./RenameDialog.module.css";

type BaseProps = Pick<DialogProps, "title" | "description" | "onClose">;

interface Props extends BaseProps {
    name: string;
    inputPlaceholder: string;
    onRename: (value: string) => void;
}

export default function RenameDialog({
    title,
    description,
    name,
    inputPlaceholder,
    onRename,
    onClose
}: Props) {
    const [value, setValue] = useState<string>(name);
    const nameValid = !!value && value !== name;

    function handleInputChange(event: Event) {
        setValue((event.target as HTMLInputElement).value);
    }

    function handleKeyDown(event: KeyboardEvent) {
        if (event.key !== Keyboard.Key.Enter) {
            return;
        }

        if (!nameValid) {
            return;
        }

        handleRenameDone();
        onClose?.();
    }

    function handleRenameDone() {
        onRename(value);
    }

    return (
        <Dialog
            class={styles.renameDialog}
            title={title}
            description={description}
            primaryButtonProps={{
                children: "Confirm",
                disabled: !nameValid,
                onClick: handleRenameDone
            }}
            secondaryButtonProps={{
                children: "Cancel"
            }}
            onClose={onClose}>
            <Input
                class={styles.input}
                value={value}
                placeholder={inputPlaceholder}
                autoFocus
                onInput={handleInputChange}
                onKeyDown={handleKeyDown}/>
        </Dialog>
    );
}
